function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "megaphone-outline",
  transform: "translate(-1.875 -1.83)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11888",
  "data-name": "Path 11888",
  d: "M37.559,3.781s-8.328,10.36-16.142,10.36H6.038A1.538,1.538,0,0,0,4.5,15.679v9.228a1.538,1.538,0,0,0,1.538,1.538H21.417c7.814,0,16.142,10.4,16.142,10.4a1.4,1.4,0,0,0,2.313-.945V4.72a1.367,1.367,0,0,0-2.313-.941Z",
  transform: "translate(0.413)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11889",
  "data-name": "Path 11889",
  d: "M4.913,19.652s-1.538-.577-1.538-3.076S4.913,13.5,4.913,13.5",
  transform: "translate(0 3.717)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11890",
  "data-name": "Path 11890",
  d: "M31.5,18.433a2.223,2.223,0,0,0,0-4.23",
  transform: "translate(10.323 3.975)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11891",
  "data-name": "Path 11891",
  d: "M18,11.25v12.3",
  transform: "translate(5.368 2.891)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11892",
  "data-name": "Path 11892",
  d: "M7.875,11.25v12.3",
  transform: "translate(1.652 2.891)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11893",
  "data-name": "Path 11893",
  d: "M10.125,20.25V36.4a.77.77,0,0,0,.77.77h5.1a1.538,1.538,0,0,0,1.47-1.993c-.807-2.585-2.72-5.5-2.72-10.312h1.538a1.538,1.538,0,0,0,1.538-1.538V21.788a1.538,1.538,0,0,0-1.538-1.538H14.739",
  transform: "translate(2.478 6.194)",
  fill: "none",
  stroke: "#ac1ede",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}));

var SvgMegaphoneOutline = function SvgMegaphoneOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42.986,
    height: 43.033,
    viewBox: "0 0 42.986 43.033",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMegaphoneOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/megaphone-outline.cfaeedca.svg";
export { ForwardRef as ReactComponent };